// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_tTwd6","foot_link":"index_foot_link_tt8pU","list":"index_list_znxRq","link":"index_link_DgiyZ","copyright":"index_copyright_ecTfD"};